<template>
  <div class="content">
    <p>
      Fråga {{step}} av {{total}}
    </p>
  </div>
</template>
<script>
export default {
  props: {
    step: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  }
}
</script>
<style lang="scss">
@import "../../assets/scss/variables";

p {
  font-weight: bold;
  color: $grey-lighter;
  font-size: $size-5 * 1.1;
}
</style>
